export const HANDLE_ORIGIN_POINT = 'HANDLE_ORIGIN_POINT';
export const HANDLE_DESTINY_POINT = 'HANDLE_DESTINY_POINT';
export const HANDLE_START_SCHEDULE = 'HANDLE_START_SCHEDULE';
export const RESET_START_SCHEDULE = 'RESET_START_SCHEDULE';
export const RESET_RETURN_SCHEDULE = 'RESET_RETURN_SCHEDULE';
export const HANDLE_RETURN_SCHEDULE = 'HANDLE_RETURN_SCHEDULE';
export const HANDLE_POINT_SELECTOR = 'HANDLE_POINT_SELECTOR';
export const HANDLE_START_DATE = 'HANDLE_START_DATE';
export const HANDLE_END_DATE = 'HANDLE_END_DATE';
export const HANDLE_TIME_REFERENCE = 'HANDLE_TIME_REFERENCE';
export const HANDLE_SERVICE_DATA = 'HANDLE_SERVICE_DATA';
export const HANDLE_NOTES = 'HANDLE_NOTES';
export const HANDLE_RETURN = 'HANDLE_RETURN';
export const HANDLE_ORIGIN = 'HANDLE_ORIGIN';
export const HANDLE_RESET = 'HANDLE_RESET';
export const HANDLE_ORIGIN_DAY = 'HANDLE_ORIGIN_DAY'











